import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ResumeService } from './resume.service';
import { Router } from "@angular/router";
import { CoreService } from '../../core/header/core.service';
import { MatDialog } from '@angular/material/dialog';
import { ResumeV2Model } from './resumeV2.model'
import { consts } from '../../consts';
import { UserCompanyService } from '../user/usercompany/usercompany.service';
import { UserModel } from '../user/user.model';
import { UserCompanyModel } from '../user/usercompany/usercompany.model';
import { ActivityService } from '../user/activity/activity.service';
import { ActualSelected } from '../../shared/utils';
import { SummaryResultModel } from './summary-result.model';

@Component({
    selector: 'convfact-resume',
    templateUrl: './resume.component.html',
    styleUrls: ['./resume.component.css'],
    standalone: false
})

export class ResumeComponent implements OnInit {

  useIVA: boolean = false;
  useIGIC: boolean = false;
  showGlobal: boolean = false;

  readyIncomes: boolean = false;
  readyExpenses: boolean = false;

  dataV2: ResumeV2Model = new ResumeV2Model();

  resumeToday = {
    generalIncomes: 0,
    generalExpenses: 0,
    generalBalance: 0,
    ivaIncomes: 0,
    ivaExpenses: 0,
    ivaBalance: 0,
    igicIncomes: 0,
    igicExpenses: 0,
    igicBalance: 0,
  }

  constructor(
    private router: Router,
    private resumeService: ResumeService,
    private activityService: ActivityService,
    public dialog: MatDialog,
    private coreService: CoreService,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this.dataV2 = new ResumeV2Model();
    this.coreService.setName("Resumen");
    this.setResumeData();
    ActualSelected.global = this.showGlobal ? '1' : '0';

    this.useIVA = false; //TODO GET from configuration
  }


  renew() {
    this.router.navigate(['/subscription']);
  }

  changeGlobal() {
    ActualSelected.global = this.showGlobal ? '1' : '0';
    this.setResumeData();
  }

  SetResumeIncomes() {
    this.readyIncomes = false;
    this.resumeService.getResumeIncomes(this.showGlobal, consts.EMPTY_GUID).then(response => {

      this.dataV2.subventions = response.subventions.sort((a, b) => a.numMonth - b.numMonth);
      this.dataV2.incomes = response.incomes.sort((a, b) => a.numMonth - b.numMonth);
      this.dataV2.incomesPaid = response.incomesPaid.sort((a, b) => a.numMonth - b.numMonth);
      this.dataV2.incomesUnPaid = response.incomesUnPaid.sort((a, b) => a.numMonth - b.numMonth);
      this.dataV2.incomesIgic = response.incomesIgic.sort((a, b) => a.numMonth - b.numMonth);
      this.dataV2.incomesIva = response.incomesIva.sort((a, b) => a.numMonth - b.numMonth);

      this.resumeService.sendData({ data: this.dataV2, global: this.showGlobal });

      this.readyIncomes = true;
      this.cdr.detectChanges();
    }).catch(err => {
      console.error('[Resume] Error cargando ingresos:', err);
      this.readyIncomes = true;
      this.cdr.detectChanges();
    });

    this.activityService.loadDataActivitiesTaxConfig(ActualSelected.activitySelected).then(activitiesTax => {
      this.useIGIC = activitiesTax.igic;
      this.useIVA = activitiesTax.iva;
      this.cdr.detectChanges();
    });

    this.resumeService.getResumeTodayIncomes(this.showGlobal, consts.EMPTY_GUID).then(response => {
      this.resumeToday.generalIncomes = response.rtIngresos;
      this.resumeToday.generalExpenses = response.rtGastos;
      this.resumeToday.generalBalance = response.rtBalance;
    });


  }

  SetResumeExpenses() {
    this.readyExpenses = false;
    this.resumeService.getResumeExpenses(this.showGlobal, consts.EMPTY_GUID).then(response => {
      this.dataV2.expenses = response.expenses;
      this.dataV2.expensesPaid = response.expensesPaid;
      this.dataV2.expensesUnPaid = response.expensesUnPaid;
      this.dataV2.expensesIgic = response.expensesIgic;
      this.dataV2.expensesIva = response.expensesIva;
      this.dataV2.expensesIrpf = response.expensesIrpf;
      this.dataV2.investmentIgic = response.investmentIgic;
      this.dataV2.expensesIgicImport = response.expensesIgicImport;

      this.resumeService.sendData({ data: this.dataV2, global: this.showGlobal });

      this.readyExpenses = true;
      this.cdr.detectChanges();
    }).catch(err => {
      console.error('[Resume] Error cargando gastos:', err);
      this.readyExpenses = true;
      this.cdr.detectChanges();
    });
  }

  setResumeData() {
    this.SetResumeIncomes();
    this.SetResumeExpenses();
  }

  // Calcula el porcentaje siempre positivo


}
